module.exports = __webpack_public_path__ + "static/media/qr-code (1).5e343bb2.png";